import compose from "ramda/src/compose";
import path from "ramda/src/path";
import ifElse from "ramda/src/ifElse";
import isNil from "ramda/src/isNil";
import prop from "ramda/src/prop";
import identity from "ramda/src/identity";
import applySpec from "ramda/src/applySpec";

const mapTag = ifElse(
  isNil,
  identity,
  applySpec({
    value: prop("id"),
    label: prop("name"),
  })
);

export const getTag = compose(mapTag, path(["tag"]));
